var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cItems.length)?_c('LazyHydrate',{attrs:{"when-visible":""}},[_c('DynamicPageItems',{attrs:{"items":_vm.cItems}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }